import 'babel-polyfill'
import 'whatwg-fetch'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './axiosConfig'
import store from './store'
import qs from 'qs'
import JsonExcel from 'vue-json-excel'
import directive from './directive/index'
import common from '../script/commonMethods.js'
import Layout from '@/views/todoCenter/default/workflow/layout/index.vue'
import wechatLayout from '@/views/todoCenter/default/wechat/layout/index.vue'
import DefaultIcon from '@/components/todoCenter/defaultIcon'
import Logo from '@/components/todoCenter/logo'
import './aiDialog/css/aiDialog.css'
import VueApollo from 'vue-apollo'
import apolloProvider from './apolloConfig'
import Cookies from "js-cookie"
import './axiosConfig'
import aiDialog from './aiDialog/js/aiDialog.js'
import VueLazyload from 'vue-lazyload'
import ant from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import visit from '@/components/todoCenter/visit'

Vue.component('DefaultIcon', DefaultIcon);
Vue.component('Logo', Logo);
Vue.component('pc', Layout);
Vue.component('mobile', wechatLayout);
Vue.component('visit', visit);

Vue.use(ant);
Vue.use(directive);
Vue.use(VueApollo);
Vue.use(ElementUI);

Vue.prototype.$common = common;

Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

Vue.component('downloadExcel', JsonExcel)
var vue = new Vue({
    el: '#app',
    data: function () {
        return {
            userName: "",
            account: ""
        }
    },
    router,
    store,
    provide: apolloProvider.provide(),
    components: {'pc': Layout, 'mobile': wechatLayout},
    render: h => h(App)
})
export default vue


// WEBPACK FOOTER //
// ./src/main.js